<template>
    <div class="mobileBook" @click="toDetail(bookInfo.id,bookInfo.chapter_id)">
        <div class="book">
            <div class="nav">
                <div class="img-box">
                    <el-image :src="bookInfo.cover_url" lazy alt="">
                <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                </div>
            </el-image>
                </div>
                <div class="nov-info">
                    <div class="title">{{ bookInfo.name }}</div>
                    <div>
                        <span>独家</span>
                        <span>{{ bookInfo.category_name }}</span>
                        <span>{{bookInfo.word_count}}字</span>
                    </div>
                    <!-- <div>上架时间:&nbsp;{{ bookInfo.create_time }}</div> -->
                </div>

            </div>
            <div class="btnbox">
                <el-button size="mini" type="warning" @click.stop="copyToClipboard(bookInfo.id)">复制书籍ID</el-button>
                <el-button size="mini" style="margin-right: 10px;" type="success" @click.stop="copyToClipboard(bookInfo.name)">复制书名</el-button>
                <!-- <el-tag type="success" @click.stop>书籍ID:{{ bookInfo.id }}</el-tag> -->
            </div>
        </div>
    </div>
</template>
  
<script>

export default {
    name: 'mobileBook',
    props: {
        bookInfo: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            clipboard: null
        }
    },
    mounted() {
    },
    methods: {
        toDetail(bid,cid) {
            this.$router.push({ path: '/detail', query: { bookid: bid,chapter_id:cid } });
        },
        copyToClipboard(id) {
            const textArea = document.createElement('textArea')
            textArea.value = id
            textArea.style.width = 0
            textArea.style.position = 'fixed'
            textArea.style.left = '-999px'
            textArea.style.top = '10px'
            textArea.setAttribute('readonly', 'readonly')
            document.body.appendChild(textArea)

            textArea.select()
            document.execCommand('copy')
            if(document.execCommand('copy')){
                    this.$message({
                        message: '内容已成功复制到剪切板',
                        type: 'success'
                    })
            }else {
                this.$message('复制失败')
            }
            document.body.removeChild(textArea)
            // navigator.clipboard.writeText(id)
            //     .then(() => {
            //         this.$message({
            //             message: '内容已成功复制到剪切板',
            //             type: 'success'
            //         })
            //     })
            //     .catch((error) => {
            //         console.error('复制到剪切板时出现错误:', error);
            //     });
        }
    }
}
</script>
  
<style scoped lang="scss">
.mobileBook {
    .book {
        padding: 15px;
        border-radius: 5px;
        background-color: #fff;
        margin-top: 10px;

        .nav {
            display: flex;

            .img-box {
                width: 48px;
                height: 64px;
                border-radius: 5px;
                overflow: hidden;
                margin-right: 14px;
                background: #f5f7fa;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .nov-info {
                color: rgba(0, 0, 0, .4);
                font-size: 12px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .title {
                    color: #000;
                }

                span {
                    margin-right: 4px;
                }
            }


        }

        .btnbox {
            display: flex;
            flex-direction: row-reverse;
            margin-top: 7px;
        }
    }

}
</style>
  